module.exports = __webpack_public_path__ + "static/img/jp_bgc2.f08a303.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/jp_bgc2.png
// module id = 5ZLh
// module chunks = 6